import { IgrColumn } from "./igr-column";
import { ColumnHiddenChangedEventArgs as ColumnHiddenChangedEventArgs_internal } from "./ColumnHiddenChangedEventArgs";
import { ensureBool } from "igniteui-react-core";
var IgrColumnHiddenChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnHiddenChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrColumnHiddenChangedEventArgs.prototype.createImplementation = function () {
        return new ColumnHiddenChangedEventArgs_internal();
    };
    Object.defineProperty(IgrColumnHiddenChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrColumnHiddenChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrColumnHiddenChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrColumnHiddenChangedEventArgs.prototype, "column", {
        get: function () {
            if (this.i.a == null) {
                return null;
            }
            if (!this.i.a.externalObject) {
                var e = IgrColumn._createFromInternal(this.i.a);
                if (e) {
                    e._implementation = this.i.a;
                }
                this.i.a.externalObject = e;
            }
            return this.i.a.externalObject;
        },
        set: function (v) {
            v == null ? this.i.a = null : this.i.a = v.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrColumnHiddenChangedEventArgs.prototype, "isHidden", {
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrColumnHiddenChangedEventArgs;
}());
export { IgrColumnHiddenChangedEventArgs };
//# sourceMappingURL=igr-column-hidden-changed-event-args.js.map
